import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-rock': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M408.9 79.1c48.8-20.8 103.1 15.1 103.1 67.9v114.4c0 15.4-3.1 30.4-9.2 44.6l-42.8 99.7c-5 11.6-4 18.9-4 42.4 0 17.7-14.3 32-32 32h-252c-17.7 0-32-14.3-32-32 0-27.3 1.1-29.2-3.1-32.9l-97.7-85.1c-24.9-21.7-39.2-52.9-39.2-85.6v-57c0-47.4 44.8-82 91-71.2 2-55.8 63.5-87.8 110.7-60.8 29.2-31.1 78.9-31.4 108.3 0 32.7-18.7 76.4-10.3 98.8 23.6zM464 261.4v-114.4c0-34.3-52-33.8-52-0.7 0 8.8-7.2 16-16 16h-7c-8.8 0-16-7.2-16-16v-26.8c0-34.5-52-33.7-52-0.7v27.4c0 8.8-7.2 16-16 16h-7c-8.8 0-16-7.2-16-16v-40.5c0-34.4-52-33.8-52-0.7v41.1c0 8.8-7.2 16-16 16h-7c-8.8 0-16-7.2-16-16v-26.8c0-34.4-52-33.8-52-0.7v116.6c0 8.8-7.2 16-16 16-3.3 0-8-1.8-10.5-3.9l-7-6.1c-3-2.6-5.5-8-5.5-12.1v0-41.2c0-34.2-52-33.9-52-0.7v57c0 18.9 8.3 36.9 22.7 49.4l97.7 85.1c12.5 10.8 19.6 26.4 19.6 42.8v10.3h220v-7.1c0-13.2 2.7-26.1 7.9-38.3l42.8-99.7c2.9-6.8 5.3-18.2 5.3-25.6v0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-rock.js
// module id = 1771
// module chunks = 0